import {
  Box,
  Group,
  Modal,
  Pagination,
  Select,
  Table,
  Text,
  TextInput,
} from "@mantine/core";
import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { AxiosCommonError } from "../../../../../shared/types";
import { handleError } from "../../../../ui/err/handleError";
import { companyApis } from "../../../../../shared/apis/company/apis";
import {
  deviceOptions,
  getSelectValue,
} from "../../../../../shared/constants/commonCode";
import useSearch from "../../../../../shared/hook/useSearch";
import { useCallback, useState } from "react";
import { debounce } from "lodash";
import { modelFilterHook } from "../../../../../shared/utils/modelFilter";

interface IPropsViewModal {
  opened: boolean;
  onClose: () => void;
  company: {
    companyName: string;
    companyId: string;
  };
}
const tableHead = ["MAC", "모델명", "S/N"];

export default function ViewModal(props: IPropsViewModal) {
  const { opened, onClose, company } = props;
  // const [page, setPage] = useState<number>(1);
  const size = 10;
  const {
    searchType,
    setSearchType,
    searchWord,
    setSearchWord,
    handleSearch,
    page,
    setPage,
  } = useSearch();
  const [deviceCd, setDeviceCd] = useState<string>("");
  const [deviceSubCd, setDeviceSubCd] = useState<string>("");

  const sendData = {
    page,
    size,
    searchWord,
    filter: {
      isAssignedYn: "Y",
      deviceCd,
      deviceSubCd,
    },
    search: {
      mac: searchType === "mac" ? searchWord : "",
      serialNum: searchType === "serialNum" ? searchWord : "",
    },
  };

  const { data: assignedList } = useQuery(
    [
      "adminModlinkList",
      company.companyId,
      page,
      deviceCd,
      deviceSubCd,
      searchWord,
      searchType,
    ],
    () => companyApis.getAdminModlinkList({ companyId: Number(company.companyId), data: sendData }),
    {
      enabled: opened && !!company.companyId,
      select: (data) => data.data,
      onError: (error: AxiosError<AxiosCommonError>) => {
        handleError(error);
      },
    }
  );

  const onChangeDeviceParams = (option: { value: string; label: string }) => {
    const { model, subType } = JSON.parse(option.value);
    setDeviceCd(model);
    setDeviceSubCd(subType);
  };

  const debouncedSetSearchWord = useCallback(
    debounce((value) => {
      setSearchWord(value);
    }, 300),
    []
  );

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title="할당된 디바이스 목록"
      size="xl"
    >
      <Text size="sm" mb="md">
        거래처명 :
        <Text fw="bold" component="span" ml={4} size="md">
          {company.companyName}
        </Text>
      </Text>
      <Group gap="xs" align="flex-end" mb="md">
        <Select
          data={deviceOptions}
          style={{ width: "150px" }}
          value={getSelectValue(deviceCd, deviceSubCd)}
          onChange={(_value, option) => onChangeDeviceParams(option)}
        />
        <Box style={{ position: "relative", flex: 1 }}>
          <TextInput
            // ref={inputRef}
            onKeyUp={handleSearch}
            onChange={(e) => debouncedSetSearchWord(e.currentTarget.value)}
            placeholder="MAC, S/N으로 검색해주세요."
            w="400px"
            styles={{
              input: { paddingInlineStart: "7.5rem" }, // 🔥 .mantine-TextInput-input에 적용
            }}
          />
          <Select
            maw="7rem"
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              input: {
                borderTopRightRadius: "0",
                borderBottomRightRadius: "0",
              },
            }}
            value={searchType || ""}
            onChange={setSearchType}
            data={[
              { value: "mac", label: "MAC" },
              { value: "serialNum", label: "S/N" },
            ]}
          />
        </Box>
      </Group>
      <Table
        withTableBorder
        captionSide="top"
        stickyHeader
        style={{ "th, td": { textAlign: "center" } }}
      >
        <Table.Thead>
          <Table.Tr>
            {tableHead.map((item) => {
              return <Table.Th key={item}>{item}</Table.Th>;
            })}
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {assignedList.data.map((item: any) => {
            return (
              <Table.Tr key={item.mac}>
                <Table.Td>{item.mac}</Table.Td>
                <Table.Td>
                  {modelFilterHook(item.deviceCd, item.deviceSubCd)}
                </Table.Td>
                <Table.Td>{item.serialNum}</Table.Td>
              </Table.Tr>
            );
          })}
        </Table.Tbody>
      </Table>
      <Group mt="lg" justify="center">
        <Pagination
          total={Math.ceil(assignedList.total / size)}
          value={page}
          onChange={setPage}
        />
      </Group>
    </Modal>
  );
}
